import { render, staticRenderFns } from "./unscrambleDetail.vue?vue&type=template&id=6b8c5b82&scoped=true&"
import script from "./unscrambleDetail.vue?vue&type=script&lang=js&"
export * from "./unscrambleDetail.vue?vue&type=script&lang=js&"
import style0 from "./unscrambleDetail.vue?vue&type=style&index=0&id=6b8c5b82&prod&lang=less&"
import style1 from "./unscrambleDetail.vue?vue&type=style&index=1&id=6b8c5b82&prod&lang=less&scoped=true&"
import style2 from "./unscrambleDetail.vue?vue&type=style&index=2&id=6b8c5b82&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c5b82",
  null
  
)

export default component.exports